"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var DoubleCell_1 = __importDefault(require("containers/TableMaker/components/DoubleCell"));
var Attachments_1 = __importDefault(require("containers/TableMaker/instances/TransactionsTable/Attachments"));
var Source = function (_a) {
    var item = _a.item;
    return ((0, jsx_runtime_1.jsx)(DoubleCell_1.default, { main: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Attachments_1.default, { size: "extraSmall", item: item, mt: -0.5 }), ' ', item.source && end2end_1.TRANSACTION_SOURCE_PLATFORM_MAPPER[item.source]] })), secondary: item.source && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [item.isLineItem && 'Line Item - ', end2end_1.TRANSACTION_SOURCE_TYPE_MAPPER[item.source]] })) }));
};
exports.default = Source;
